import Api from "~/service/Api";

class InvoicePaymentRepository {
  create(data) {
    return Api.post("/invoice-payments", data);
  }
}

export default InvoicePaymentRepository;
